import React from "react";
import AdminTittle from "../../components/adminComponents/AdminTittle";
import SuperAdminHeader from "../../components/superAdminCompoents/SuperAdminHeader";
import SuperAdminSidebar from "../../components/superAdminCompoents/SuperAdminSidebar";
import AdminLoginInfoComponent from "../../components/superAdminCompoents/superAdminViewLoginAdminInfo/AdminLoginInfoComponent";

const AdminLoginInfo = () => {
  return (
    <>
      {/* <SuperAdminHeader />
            <SuperAdminSidebar /> */}
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <AdminTittle title="Logged-in Admin Information" />
            <AdminLoginInfoComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLoginInfo;
